import { useEffect, useState, useContext } from 'react'
import FormChangePasswordModal from '../../components/FormChangePasswordModal'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import ProfileGimba from '../../components/ProfileGimba'
import ProfileSideMenu from '../../components/MenuProfile'
import DadosCadastroPJ from '../../components/DadosCadastroPJ'
import DadosCadastroPF from '../../components/DadosCadastroPF'
import TokenParceria from '../../components/TokenParceria'
import PromotorVendas from '../../components/PromotorVendas'
import { ProfileTitle } from '../../components/FormChangePassword/styles'
import * as S from '../../styles/page-profile'
import { Breadcrumb, BreadcrumbItem } from '../../styles/breadcrumb'
import { authCheck } from '../../api/auth/auth'
import { fetchUser } from './fetch'
import Loader from '../../components/Loader'
import FormChangeEmailModal from '../../components/FormChangeEmailModal'
import { useQuery } from '../../hooks/useQuery'
import {
  getLocalStorageLog,
  getQueryParamsToTracelog
} from '../../utils/traceLogAcessos'

import { useLocation } from 'react-router-dom'
import { UserContext } from '../../contexts/UserContext'

function MeuPerfil() {
  const { getUserData, user, setUser, loading } = useContext(UserContext)
  //modal state
  const [showModal, setShowModal] = useState(false)
  const [showEmailModal, setShowEmailModal] = useState(false)

  const openModal = () => {
    setShowModal((prev) => !prev)
  }

  const openEmailModal = () => {
    setShowEmailModal((prev) => !prev)
  }
  //state - redux
  // const [formValues, setFormvalues] = useState({})
  const [refresh, setRefresh] = useState(false)
  const [load, setLoad] = useState(false)

  const handleChange = (value, field) => {
    setUser((prev) => ({
      ...prev,
      [field]: value
    }))
  }

  const query = useQuery()

  const location = useLocation()

  useEffect(() => {
    getQueryParamsToTracelog(query)
    getLocalStorageLog(location.pathname)
  }, [])

  // useEffect(() => {
  //   authCheck()
  //   fetchUser(setFormvalues, setLoad)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [refresh])

  // useEffect(() => {
  //   getUserData()
  // }, [])

  // console.log(store.user.info)

  return (
    <S.Main>
      {loading && <Loader />}

      <FormChangePasswordModal
        showModal={showModal}
        setShowModal={setShowModal}
      />

      <FormChangeEmailModal
        showModal={showEmailModal}
        setShowModal={setShowEmailModal}
      />

      <Header />
      <S.Profile className="perfil">
        <S.PageContent className="page-content">
          <S.Wrapper className="wrapper">
            <S.ColGroup className="col-group">
              <ProfileSideMenu />
              <S.ProfileContent className="col-9">
                {/* Área para inserir os novo componentes criados para ficar ao lado do menu lateral de perfil */}
                <Breadcrumb>
                  <BreadcrumbItem>Inicio</BreadcrumbItem>
                  <BreadcrumbItem>Dados de Cadastro</BreadcrumbItem>
                </Breadcrumb>
                <ProfileTitle>Dados de Cadastro</ProfileTitle>
                {user.tipoCliente === 'F' ? (
                  <DadosCadastroPF
                    refreshUserData={setRefresh}
                    refresh={refresh}
                    userData={user}
                    onChange={handleChange}
                    alterarSenha={() => openModal()}
                    alterarEmail={() => openEmailModal()}
                  ></DadosCadastroPF>
                ) : (
                  <DadosCadastroPJ
                    refreshUserData={setRefresh}
                    refresh={refresh}
                    userData={user}
                    onChange={handleChange}
                    alterarSenha={() => openModal()}
                    alterarEmail={() => openEmailModal()}
                  />
                )}
                <ProfileGimba />
                {user.tipoCliente === 'F' && (
                  <PromotorVendas
                    onChange={handleChange}
                    userData={user}
                    refreshUserData={setRefresh}
                    refresh={refresh}
                  />
                )}
                {user.tipoCliente === 'F' && <TokenParceria />}

                {/* Fim da área de conteúdo da página */}
              </S.ProfileContent>
            </S.ColGroup>
          </S.Wrapper>
        </S.PageContent>
      </S.Profile>

      <Footer />
    </S.Main>
  )
}

export default MeuPerfil
